import type { HamrahPlayerRef } from 'hamrah-player';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useRef, useState } from 'react';

import type { IButtonProps } from '@/DesignSystem/Model/DataModel';
import { useLoggedIn } from '@/Module/Auth/Hook';
import { LINKS } from '@/Module/Core/Constant';
import { VideoLoginService } from '@/Module/Core/Service';
import { selectedLessonSectionSelector } from '@/Module/Lesson/Store/Selector/selectedLessonSectionSelector';
import { useAppSelector } from '@/Module/Store/Hook';

export const useVideoDuration = () => {
  const router = useRouter();
  const isLoggedIn = useLoggedIn();

  const [isValid, setValid] = useState(true);
  const lessonId = useAppSelector(state => selectedLessonSectionSelector(state)?.id);
  const intervalHandler = useRef<ReturnType<typeof setInterval>>();
  const currentTime = useRef(0);
  const videoDuration = new VideoLoginService();
  const videoDurationSubscription = new VideoLoginService('subscription');

  const stopInterval = () => {
    if (intervalHandler.current) clearInterval(intervalHandler.current);
  };

  const startInterval = () => {
    if (!lessonId || isLoggedIn) return;

    stopInterval();
    intervalHandler.current = setInterval(() => {
      if (!videoDuration.canContinueWatching(lessonId)) {
        setValid(false);
        stopInterval();

        return;
      }
      videoDuration.increaseVideoDuration(lessonId);
      videoDurationSubscription.increaseVideoDuration(lessonId);
    }, 1000);
  };

  const onPlay = useCallback(() => {
    startInterval();
  }, [lessonId]);

  const onPause = useCallback(() => {
    stopInterval();
  }, [lessonId]);

  const onTimeUpdate = useCallback(
    (player: HamrahPlayerRef) => {
      currentTime.current = player?.currentTime();
    },
    [lessonId],
  );

  const onLoginClick: IButtonProps['onClick'] = event => {
    event.preventDefault();
    router.push(`${LINKS.AUTH.LOGIN}?redirectUrl=${encodeURI(router.asPath)}`);
  };

  useEffect(() => {
    if (!lessonId || isLoggedIn) return () => {};

    videoDuration.reloadLocalStorage().then(() => {
      setValid(videoDuration.canContinueWatching(lessonId));
    });

    return () => {
      stopInterval();
    };
  }, [lessonId]);

  /*  useEffect(() => {
    if (isLoggedIn) videoDuration.clear();
  }, [isLoggedIn]); */

  /*
  useEffect(() => {
    if (isLoggedIn || isValid) return () => {};

    const modalTimeHandler = setTimeout(() => {
      dispatch(showVideoLoginModal(true));
    }, 10000);
    return () => clearTimeout(modalTimeHandler);
  }, [isValid]);
*/

  return {
    isValid: isLoggedIn || isValid,
    onPlay,
    onPause,
    onTimeUpdate,
    onLoginClick,
  };
};
